import React from "react";
import { Block } from "@randajan/jet-react/dom/block";

import "./NextGame.scss";

import { Locale } from "../../../assets/Locale";
import { useBeam } from "@randajan/bifrost/client/react";
import { isBefore, isFuture, isValid } from "date-fns";
import { eventsBeam } from "../../../assets/beams/eventsBeam";
import { Timer } from "../../../elements/Clocks/Timer/Timer";
import { Button } from "@randajan/jet-react/dom/form";

const findNextEvent = (eventsEntries)=>{
    if (!Array.isArray(eventsEntries)) { return; }
    let nextEventStart;
    for (const event of eventsEntries) {
        if (event.status !== "published") { break; }
        const startAt = new Date(event.startAtEst);
        if (!isValid(startAt)) { continue; }
        nextEventStart = startAt;
    }
    return nextEventStart;
}

export const NextGame = (props)=>{
    const {} = props;
    const { data:events } = useBeam(eventsBeam);
    const say = Locale.use();

    const nextEventStart = findNextEvent(events);
    const gameSheduled = isFuture(nextEventStart);
    const phraseId = gameSheduled ? "landingNextGameScheduled" : "landingNextGamePreparing";

    return (
        <Block className="NextGame" caption={say(phraseId)}>
            {gameSheduled && <Timer
                value={nextEventStart}
                clockOpt={{ includeSeconds:true, zeros:false }}
                targetOpt={{ weekday:"long", month:"long" }}
            />}
            <Button onSubmit={()=>{
                window.open("/r/temp-reservation")
            }}>{say("reservationGroup")}</Button>
        </Block>
    );
};
